import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';

type PostChallenge2FAResponse = {
  totpEnabled: boolean;
};

export const usePostChallenge2FAMutation = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: PostChallenge2FAResponse) => void;
    onError?: (any: unknown) => void;
  } = {
    onSuccess: undefined,
    onError: undefined,
  }
) => {
  return useMutation({
    mutationFn: async ({ totpCode }: { totpCode: string }) => {
      const { data } = await client.post<{
        body: PostChallenge2FAResponse;
      }>(`/auth/2fa/totp/challenge`, {
        totpCode,
      });

      return data.body;
    },
    onSuccess,
    onError,
  });
};
